interface IHotelCancelTypes {
  percent: string;
  fixed: string;
}

export const HotelCancelTypes: IHotelCancelTypes = {
  percent: "percent",
  fixed: "fixed",
};
